<template>
  <article>
    <header>
      <h1 class="title">
        {{ $t(title) }}
      </h1>
    </header>
    <main>
      <template v-for="(block, i) in blocks">
        <NewsletterTextBlock v-if="block.type == 'text'" :data="block" :key="i" />
      </template>
    </main>
  </article>
</template>
<script>
import dynamicLocalization from "@/mixins/dynamic-localization"
import NewsletterTextBlock from "@/components/newsletter/blocks/Text.vue"

export default {
  mixins: [dynamicLocalization],
  components: {
    NewsletterTextBlock,
  },
  data() {
    return {
      title: {
        de: "Ticketverkauf beendet",
        en: "Ticket Shop Closed",
      },
      blocks: [
        {
          type: "text",
          content: {
            de: "Alle verfügbaren Tickets für die bevorstehende Party sind verkauft. Daher ist der Ticketshop ab sofort geschlossen.",
            en: "All available tickets for the upcoming party has been sold. Therefore our ticket shop is now closed.",
          }
        },
        {
          type: "text",
          content: {
            segments: [
              {
                content: {
                  de: "Wir planen keinen weiteren Ticketverkauf für diese Party, auch nicht an der Abendkasse. Falls du deine Chance auf dein Ticket verpasst haben solltest, schau doch mal in unserer ",
                  en: "We have no plans of another ticket sale for this event, not even at that evening. If you have missed your chance for a ticket, head over to our ",
                }
              },
              {
                format: "url",
                href: "https://t.me/+V696c2fBFYs4NmYy",
                content: {
                  de: "Telegram-Gruppe",
                  en: "Telegram group",
                }
              },
              {
                content: {
                  de: " vorbei. Üblicherweise stellt sich in den Tagen vor der Party heraus, dass einige Ticketbesitzer nicht zur Party kommen können und daher ihr Ticket an andere Gruppenmitglieder weiterverkaufen wollen.",
                  en: ". Ususally we experience a bunch of people which can't make it to the party and therefore trying to resell their ticket to other group members in the days before the event.",
                }
              },
            ],
          },
        },
        {
          type: "text",
          content: {
            segments: [
              {
                content: {
                  de: "Falls du für die nächsten Partys informiert bleiben möchtest, abonniere gerne unseren ",
                  en: "If you want to stay informed about our next parties, subscribe to our ",
                },
              },
              {
                format: "internal-url",
                name: "newsletter",
                content: {
                  de: "Newsletter",
                  en: "newsletter",
                },
              },
              {
                content: {
                  de: " oder finde dich in unserem ",
                  en: " or check out our "
                }
              },
              {
                format: "url",
                href: "https://t.me/frechdax_abdl",
                content: {
                  de: "Frechdax München Infokanal auf Telegram",
                  en: "Frechdax München info channel on Telegram",
                }
              },
              {
                content: {
                  de: " ein. Dort geben wir auch den nächsten Partytermin bekannt.",
                  en: ". There we will announce the next party date, too."
                }
              }
            ]
          }
        },
        {
          type: "text",
          content: {
            de: "Wir hoffen, dich bald zu sehen!",
            en: "We hope to see you soon!",
          }
        }
      ],
    }
  }
}
</script>
